import React from 'react';
import {View} from 'react-native';

import Screen from '../../shared/components/screen';

import {Props} from './model';
import {Breadcrumbs} from '../../shared/components/breadcrumbs';
import {Routes, Screens} from '../../shared/routing';
import {DeviceSize, useDeviceSize} from '../../shared/theme/helpers';
import {ResponsiveView} from '../../shared/components/responsiveView';
import {Hr} from '../../shared/components/hr';
import {ContactsCard} from '../../shared/components/contactsCard';
import {Button} from '../../shared/components/button';
import {Text} from '../../shared/components/text';
import {Image} from '../../shared/components/image';
import {Markdown} from '../../shared/components/markdown';
import {images} from '../../assets/icons';
import {Banking} from '../../assets/images';
import {formatPhone, formatUrl, openExternalLink, openExternalPhone} from '../../shared/pipes';
import {CustomScrollView} from '../../shared/components/scrollView';
import {GetStyles} from './style';
import {ContentWithRightImage} from '../../shared/components/contentWithRightImage';

const routes = [
  {
    title: 'Возможности карты',
    routeName: Screens.CardServices,
    webRoute: Routes.cardService,
  },
  {
    title: 'Банковские сервисы',
    routeName: Screens.BankingService,
    webRoute: Routes.bankingService,
  },
];

export default ({content}: Props) => {
  const deviceSize = useDeviceSize();
  const styles = GetStyles(deviceSize);
  const getWidthByDesktopAndBank = (bankWebSite: string = '', _deviceSize: DeviceSize) => {
    const key = bankWebSite.includes('pochta') ? 'pochta' : bankWebSite.includes('vtb') ? 'vtb' : 'skb';
    const screenKey = _deviceSize === DeviceSize.desktop ? 'desktop' : 'mobile';

    const widthConfig = {
      pochta: {
        desktop: undefined,
        mobile: 100,
      },
      vtb: {
        desktop: 318,
        mobile: 135,
      },
      skb: {
        desktop: 318,
        mobile: 290,
      },
    };

    return widthConfig[key][screenKey];
  };

  return (
    <Screen style={styles.screen}>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          <Breadcrumbs routes={routes} />
          <ResponsiveView only={[DeviceSize.desktop]}>
            <Text testID='banking-service-label-id' type='h2' style={styles.sectionTitle}>
              Банковские сервисы
            </Text>
          </ResponsiveView>
          <ContentWithRightImage
            containerStyle={styles.contentWithRightImageContainer}
            icon={<Image source={Banking as any} width={440} height={400} />}
            backgroundStyle={styles.contentWidthRightImageBackground}>
            <View style={styles.contentTextWrapper}>
              <Markdown listColumns={deviceSize === DeviceSize.desktop ? 2 : 1}>
                {content.services.bankingService.descriptionMarkdown}
              </Markdown>
            </View>
            <Hr marginBottom={30} marginTop={deviceSize === DeviceSize.desktop ? 30 : 0} />
            <View style={styles.contacts}>
              <ContactsCard
                contacts={[
                  {
                    icon: images.Phone,
                    value: formatPhone(content.services.bankingService.bankPhone),
                    onPress: () => openExternalPhone(content.services.bankingService.bankPhone),
                  },
                  {
                    icon: images.Globe,
                    value: formatUrl(content.services.bankingService.bankWebsite),
                    onPress: () => openExternalLink(content.services.bankingService.bankWebsite),
                  },
                ]}
                imageProps={{
                  source: {uri: content.services.bankingService.logoUrl},
                  width: getWidthByDesktopAndBank(content.services.bankingService.bankWebsite, deviceSize),
                  height: deviceSize === DeviceSize.desktop ? 100 : 47,
                }}
              />
            </View>
            {content.services.bankingService.bankEntryLink ? (
              <View style={styles.openBankButton}>
                <Button
                  id='bank-lk'
                  onPress={() => openExternalLink(content.services.bankingService.bankEntryLink)}
                  block={true}
                  type='secondary'
                  text='Войти в личный кабинет банка'
                />
              </View>
            ) : null}
          </ContentWithRightImage>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
